module.exports = __webpack_public_path__ + "static/media/attachments.06f9893a.png";